import { Button, Table } from "react-bootstrap"
import { GlgLoadingSpinner } from 'SharedComponents';
import React, { useState, useEffect } from "react"
import { useGetCoursesQuery } from "../api/courses"
import { coursesApi } from '../api/courses';
import { Course } from "./course";
import { useDispatch, useSelector } from "react-redux";
import { setCourseCount } from "../store/miscSlice";

const PAGE_SIZE = 20;

export const CourseTable = () => {
  const [totalPagesRendered, setTotalPagesRendered] = useState(1);

  const totalPagesRequested = totalPagesRendered + 1
  
  const prefetchCourses = coursesApi.usePrefetch('getCourses');

  const filters = useSelector(state => state.filters)
  const dispatch = useDispatch()

  const { 
    data,
    isLoading, 
    isFetching,
    error,
  } = useGetCoursesQuery({ page: totalPagesRendered, filters: filters }, 
                         { refetchOnMountOrArgChange: true }); 

  const courses = data?.courses

  useEffect(() => {
    if (courses && !isFetching) {
      
      const expectedLength = totalPagesRequested * PAGE_SIZE;
      if (courses.length === expectedLength) {
        const nextPageToPrefetch = totalPagesRendered + 1; 

        prefetchCourses(
          { page: nextPageToPrefetch, filters }, 
          { force: true, subscription: false }
        );
      }
    }
  }, [courses, isFetching, totalPagesRequested, prefetchCourses]);

  useEffect(() => {
    dispatch(setCourseCount(data?.count))
  }, [data?.count])

  useEffect(() => {
    setTotalPagesRendered(1)
  }, [filters])

  const handleLoadMore = () => {
    setTotalPagesRendered(prev => prev + 1); 
  };
  
  if (isLoading && !courses) 
    return( 
      <div className="courses-spinner-container">
        <GlgLoadingSpinner/>
      </div>);
    
  const isFetchingMore = isFetching && totalPagesRequested > totalPagesRendered;
  
  const showLoadMore = courses.length >= totalPagesRendered * PAGE_SIZE;

  return(
    <>
      <Table striped bordered hover responsive className="tables_v2">
        <thead>
          <tr>
            <th className="check_col"></th>
            <th>Name</th>
            <th>Location</th>
            <th>Compliance Status</th>
            <th>Abbreviation</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses?.length > 0 ? (
            courses.map((course) => (
              <Course key={course.id} course={course} />
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 white-bg">
                No courses found matching your filter criteria.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {
        showLoadMore ?
        <div className="justify-center">
          <Button 
            onClick={handleLoadMore} 
            disabled={isFetchingMore}
            variant="secondary"
          >
            {isFetchingMore ? 'Loading Next Page...' : 'Load More'}
          </Button>
        </div>
        :
        <div className="justify-center">All Courses Loaded</div>
      }
    </>
  )
}